import test from './test'
import zone from './zone'
import course from './course'
import teacher from './teacher'
import user from './user'
import comm from './comm'
import setting from './setting'
import student from './student'
import role from './role'
import perm from './permission'
import signup from './signup'
import clazz from './clazz'
import biz from './biz'
import schedule from './schedule'
import task from './task'
import report from './report'

export default {
    test,
    user,
    comm,
  	zone,
  	course,
  	teacher,
  	setting,
  	student,
    role,
    perm,
    signup,
    clazz,
    biz,
    schedule,
    task,
    report
}
